import React, { useState } from 'react';

import ManagedInput from 'components/form/managed_input';
import Button from 'shared/button';

interface Props {
  failedDisplayName?: string;
  isCreating?: boolean;
  type: string;
  onCancel: () => void;
  onSubmit: (displayName: string) => void;
}

export default function DisplayNameForm({ failedDisplayName, isCreating, type, onCancel, onSubmit }: Props) {
  const [displayName, setDisplayName] = useState('');

  return (
    <div className="border rounded px-3 py-3 mt-1">
      <div className="mb-2 small">
        "{failedDisplayName}" is already in use by a QuickBooks object. Enter a unique display name.
      </div>
      <ManagedInput
        aria-label="display name"
        autoFocus
        className="form-control form-control-sm mb-2"
        name="displayName"
        type="text"
        value={displayName}
        onValueChange={setDisplayName}
      />
      <div className="d-flex gap-2">
        <Button.Primary
          disabled={!displayName || isCreating}
          size="sm"
          onClick={() => onSubmit(displayName)}
        >
          Create QuickBooks {type}
        </Button.Primary>
        <Button.Cancel disabled={isCreating} size="sm" onClick={onCancel} />
      </div>
    </div>
  );
}
